import {useState, useEffect} from 'react';

import * as DentalKnowledgeApi from '../api/DentalKnowledgeApi';
import PageShell from '../components/PageShell';
import DentalKnowledgeList from '../components/DentalKnowledgeList';

export default function DentalKnowledgement() {
  const [dentalKnowledges, setDentalKnowledges] = useState([]);

  useEffect(() => {
    DentalKnowledgeApi.getAllDentalKnowledge()
      .then((res) => {
        if (Array.isArray(res)) {
          setDentalKnowledges(res);
        } else {
          console.error('API returned non-array:', res);
          setDentalKnowledges([]);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch dental knowledge:', err);
        setDentalKnowledges([]);
      });
  }, []);

  return (
    <PageShell title="Dental Education" showBackButton={true}>
      <p
        style={{
          margin: '12px 2px 0',
          fontFamily: 'var(--font-body), Manrope, system-ui',
          fontSize: 15,
          lineHeight: 1.5,
          color: '#6B7280',
        }}
      >
        Plain-language guides to common dental topics.
      </p>

      <div style={{marginTop: 24}}>
        <ul
          style={{
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
          }}
        >
          {dentalKnowledges.map((dentalKnowledge) => (
            <DentalKnowledgeList
              id={dentalKnowledge.id}
              key={dentalKnowledge.id}
              title={dentalKnowledge.title}
              date={dentalKnowledge.update_date}
              image={dentalKnowledge.cover_image}
            />
          ))}
        </ul>
      </div>
    </PageShell>
  );
}
